import React from 'react';
import { FILTER_COLOR_BOXES } from '@/app/constants/filtercolors';
import { IProduct } from '@mybestbrands/types';
import styles from '../style.module.scss';

interface ColorBoxOverlayProps {
  customSize?: string;
  colorVariantItems?: IProduct[];
}

const ColorBoxOverlay = ({ customSize = '20px', colorVariantItems }: ColorBoxOverlayProps) => {
  if (!colorVariantItems) return null;

  const MAX_VISIBLE_COLORS = 3;
  const remainingColorsCount = colorVariantItems.length - MAX_VISIBLE_COLORS;

  const renderColors = () => {
    return colorVariantItems.slice(0, 3).map((product: IProduct) => {
      const color = product?.colorTags[0];
      let boxImage;

      // Handle the case for multi-colored or multi
      if (color === 'multi-colored' || color === 'multi') {
        boxImage = FILTER_COLOR_BOXES['multi-colored'].hexCode;
      }

      const borderColor = color === 'black' ? '#808080' : 'transparent';

      return (
        <div key={product.productId}>
          <div
            className="position-relative border-1 align-self-center"
            style={{
              backgroundColor: FILTER_COLOR_BOXES[color]?.hexCode,
              backgroundImage: boxImage,
              width: customSize,
              height: customSize,
              borderRadius: '50%',
              border: `1px solid ${borderColor}`,
            }}
          />
        </div>
      );
    });
  };

  return (
    <div className={styles['colorWrapper']}>
      {renderColors()}
      {remainingColorsCount > 0 && (
        <div
          className={styles['colorCounter']}
          style={{
            width: customSize,
            height: customSize,
          }}>
          +{remainingColorsCount}
        </div>
      )}
    </div>
  );
};

export default ColorBoxOverlay;
